import { Alert, getSize } from 'metrix-common3';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { FROZEN_FIELD_LABEL_IDS } from '../../../../constants/policy/editScope';

// Shown on every Profile tab when the policy is in a read-only status but the session may still
// edit it (an administrator on a bound or issued SecureMyOffer policy): says what stays locked.
// Set off from the page header above it.
const NoticeWrapper = styled.div`
    margin-top: ${getSize('md')}px;
`;

const BoundPolicyNotice = (props) => {
    const intl = useIntl();
    const editScope = props.editScope;

    if (!editScope?.isReadOnly || !editScope?.canEdit) {
        return null;
    }

    const lockedFields = (editScope.frozenFields ?? []).map((code) =>
        intl.formatMessage({ id: FROZEN_FIELD_LABEL_IDS[code] ?? 'Profile_BoundPolicyNotice.field.unknown' }, { code }),
    );

    // Alert renders items as { code, value }, the shape of an Operation message.
    const items = [
        { code: 'body', value: intl.formatMessage({ id: 'Profile_BoundPolicyNotice.body' }) },
        ...(lockedFields.length > 0
            ? [
                  {
                      code: 'locked',
                      value: intl.formatMessage(
                          { id: 'Profile_BoundPolicyNotice.locked' },
                          { fields: lockedFields.join(', ') },
                      ),
                  },
              ]
            : []),
        { code: 'documents', value: intl.formatMessage({ id: 'Profile_BoundPolicyNotice.documents' }) },
    ];

    return (
        <NoticeWrapper>
            <Alert mode='info' header={intl.formatMessage({ id: 'Profile_BoundPolicyNotice.header' })} items={items} />
        </NoticeWrapper>
    );
};

export default BoundPolicyNotice;
